/* Quietta — storefront behaviour. No dependencies. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const designMode = !!(window.Shopify && Shopify.designMode);

  /* English: the site's texts are written in Spanish; window.QI18N (snippets/i18n-en) holds their English
     version. Swapped before anything else runs, and again for content added later (cart, messages). */
  const dict = window.QI18N;
  if (dict) {
    const tr = (s) => dict[s.replace(/\s+/g, ' ').trim()];
    const ATTRS = ['alt', 'placeholder', 'aria-label', 'title', 'data-msg-next', 'data-msg-best'];
    const swapText = (n) => {
      const v = tr(n.nodeValue);
      if (v) n.nodeValue = n.nodeValue.match(/^\s*/)[0] + v + n.nodeValue.match(/\s*$/)[0];
    };
    const translate = (el) => {
      const w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, { acceptNode: (n) => (n.parentElement && n.parentElement.closest('script, style') ? 2 : 1) });
      while (w.nextNode()) swapText(w.currentNode);
      [el, ...el.querySelectorAll('*')].forEach((x) => ATTRS.forEach((a) => {
        const v = x.getAttribute && x.getAttribute(a);
        const t = v && tr(v);
        if (t) x.setAttribute(a, t);
      }));
    };
    translate(document.body);
    document.title = document.title.split(' · ').map((p) => tr(p) || p).join(' · ');
    new MutationObserver((ms) => ms.forEach((m) => m.addedNodes.forEach((n) => {
      if (n.nodeType === 1) translate(n);
      else if (n.nodeType === 3) swapText(n);
    }))).observe(document.body, { childList: true, subtree: true });
  }

  /* English policies: Shopify stores one text per policy, the English one comes from snippets/policies-en */
  const polEl = document.getElementById('policies-en');
  if (polEl) {
    const all = JSON.parse(polEl.textContent);
    const key = (location.pathname.match(/\/policies\/([\w-]+)/) || [])[1] || (/\/pages\/cookies/.test(location.pathname) ? 'cookies' : '');
    const pol = all[key];
    const body = document.querySelector('.shopify-policy__body .rte, .shopify-policy__body, main .rte');
    const title = document.querySelector('.shopify-policy__title h1, .shopify-policy__title, main h1');
    if (pol && body) {
      body.innerHTML = pol.html;
      if (title) title.textContent = pol.title;
      document.title = 'Quietta · ' + pol.title;
    }
  }

  /* Keep the chosen language: links written as "/pages/…" get the language prefix ("/en/pages/…") */
  const localeRoot = root.replace(/\/$/, '');
  if (localeRoot) {
    const localize = (a) => {
      const h = a.getAttribute('href');
      if (!h || !h.startsWith('/') || h.startsWith('//') || h === localeRoot || h.startsWith(localeRoot + '/') || h.startsWith(localeRoot + '#') || /^\/(cdn|checkouts?|services|apps|account\/logout)\b/.test(h)) return;
      a.setAttribute('href', localeRoot + h);
    };
    $$('a[href^="/"]').forEach(localize);
    // links added later (cart drawer, sections reloaded) are fixed when clicked
    document.addEventListener('click', (e) => { const a = e.target.closest('a[href^="/"]'); if (a) localize(a); }, true);
  }

  /* Header border once the page scrolls ---------------------------------- */
  const header = $('[data-header]');
  const onScroll = () => header && header.classList.toggle('is-scrolled', scrollY > 8);
  addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* Drawers (native <dialog>: focus trap, Esc and inert page for free) ----- */
  const openDrawer = (id) => {
    const d = document.getElementById(id);
    if (!d || d.open) return;
    d.showModal();
    // showModal focuses the close button; keep the ring for keyboard users only
    if (!keyboardUser) document.activeElement?.blur();
    document.documentElement.style.overflow = 'hidden';
  };
  let keyboardUser = false;
  addEventListener('keydown', () => { keyboardUser = true; });
  addEventListener('pointerdown', () => { keyboardUser = false; });
  $$('dialog.drawer, dialog.sheet').forEach((d) => {
    d.addEventListener('close', () => { document.documentElement.style.overflow = ''; });
    // Click on the backdrop (outside the panel) closes it
    d.addEventListener('click', (e) => {
      if (e.target !== d) return;
      const r = d.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) d.close();
    });
  });

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) return openDrawer(opener.dataset.drawerOpen);
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) return closer.closest('dialog').close();
    const cartLink = e.target.closest('[data-cart-open]');
    if (cartLink && !e.metaKey && !e.ctrlKey) {
      e.preventDefault();
      openDrawer('cart-drawer');
    }
    // Close open language popovers when clicking elsewhere
    $$('[data-loc][open]').forEach((d) => { if (!d.contains(e.target)) d.open = false; });
  });

  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-autosubmit]')) e.target.form.submit();
  });

  /* Page transition: fade out before leaving --------------------------------- */
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href]');
    if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (a.target && a.target !== '_self') return;
    if (a.hasAttribute('download') || a.closest('[data-no-fade], [data-cookie-open]') || a.getAttribute('href').startsWith('#')) return;
    const url = new URL(a.href, location.href);
    if (url.origin !== location.origin) return;
    if (url.pathname === location.pathname && url.search === location.search && url.hash) return;
    e.preventDefault();
    document.body.classList.add('is-leaving');
    setTimeout(() => { location.href = url.href; }, 220);
  });

  /* Scroll reveals ----------------------------------------------------------- */
  const revealer = new IntersectionObserver((entries) => {
    entries.forEach((en) => {
      if (!en.isIntersecting) return;
      en.target.classList.add('is-in');
      revealer.unobserve(en.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

  /* Looping animations pause while their section is off screen */
  const pauser = new IntersectionObserver((entries) => {
    entries.forEach((en) => en.target.classList.toggle('is-paused', !en.isIntersecting));
  });

  /* Light parallax on product renders */
  let parallaxItems = [];
  let ticking = false;
  const parallax = () => {
    ticking = false;
    const vh = innerHeight;
    parallaxItems.forEach((el) => {
      const r = el.getBoundingClientRect();
      if (r.bottom < -100 || r.top > vh + 100) return;
      const offset = Math.max(-28, Math.min(28, (r.top + r.height / 2 - vh / 2) * -0.06));
      el.style.setProperty('--py', offset.toFixed(1) + 'px');
    });
  };
  addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(parallax); } }, { passive: true });

  /* Sliders: prev/next buttons scroll a scroll-snap track */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-slider-prev], [data-slider-next]');
    if (!btn) return;
    const track = document.getElementById(btn.dataset.sliderPrev || btn.dataset.sliderNext);
    if (track) track.scrollBy({ left: (btn.dataset.sliderPrev ? -1 : 1) * track.clientWidth * 0.9, behavior: 'smooth' });
  });

  /* Cart ------------------------------------------------------------------- */
  const cartSection = () => document.getElementById('shopify-section-cart-drawer');

  const renderCart = (html) => {
    const section = cartSection();
    if (!section || !html) return;
    const fresh = new DOMParser().parseFromString(html, 'text/html').getElementById('shopify-section-cart-drawer');
    if (fresh) section.innerHTML = fresh.innerHTML;
    const count = Number($('[data-cart]', section)?.dataset.count || 0);
    $$('[data-cart-count]').forEach((el) => { el.textContent = count; el.hidden = count === 0; });
  };

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('#cart-drawer [data-line]');
    if (!btn) return;
    const cart = $('[data-cart]');
    cart.classList.add('is-loading');
    try {
      const res = await fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(btn.dataset.line), quantity: Number(btn.dataset.qty), sections: 'cart-drawer' }),
      });
      const data = await res.json();
      renderCart(data.sections && data.sections['cart-drawer']);
    } finally {
      $('[data-cart]')?.classList.remove('is-loading');
    }
  });

  // "Change to this pack": the pack in the cart is swapped for the bigger one in a single request
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('#cart-drawer [data-swap]');
    if (!btn) return;
    const updates = { [btn.dataset.swapTo]: 1 };
    if (btn.dataset.swapFrom) updates[btn.dataset.swapFrom] = 0;
    $('[data-cart]')?.classList.add('is-loading');
    try {
      const res = await fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates, sections: 'cart-drawer' }),
      });
      const data = await res.json();
      renderCart(data.sections && data.sections['cart-drawer']);
    } finally {
      $('[data-cart]')?.classList.remove('is-loading');
    }
  });

  // Timed offer countdowns (top bar, above Add to cart, cart): days, hours, minutes, seconds; gone when it ends
  const pad = (n) => String(n).padStart(2, '0');
  const tickOffer = () => {
    $$('[data-offer-end]').forEach((el) => {
      const left = Number(el.dataset.offerEnd) - Math.floor(Date.now() / 1000);
      if (left <= 0) { el.hidden = true; return; }
      const parts = { d: Math.floor(left / 86400), h: Math.floor(left / 3600) % 24, m: Math.floor(left / 60) % 60, s: left % 60 };
      $$('[data-cd]', el).forEach((b) => {
        const txt = pad(parts[b.dataset.cd]);
        if (b.textContent !== txt) b.textContent = txt;
      });
    });
  };
  tickOffer();
  setInterval(tickOffer, 1000);

  // Order held for 10 minutes: the countdown lives in the tab session and restarts when it runs out
  const HOLD_MS = 10 * 60 * 1000;
  const tickHold = () => {
    const el = $('#cart-drawer[open] [data-hold-time]');
    if (!el) return;
    const now = Date.now();
    let end = 0;
    try { end = Number(sessionStorage.getItem('quietta-hold')) || 0; } catch (err) {}
    if (end <= now) {
      end = now + HOLD_MS;
      try { sessionStorage.setItem('quietta-hold', String(end)); } catch (err) {}
    }
    const s = Math.ceil((end - now) / 1000);
    const txt = String(Math.floor(s / 60)).padStart(2, '0') + ':' + String(s % 60).padStart(2, '0');
    el.closest('[data-hold]')?.classList.toggle('is-ending', s <= 120);
    if (el.textContent !== txt) el.textContent = txt; // unchanged text must not re-trigger the observer below
  };
  setInterval(tickHold, 1000);
  // right away when the drawer opens or is re-rendered, so it never shows a stale 10:00
  const cartDialog = document.getElementById('cart-drawer');
  if (cartDialog) new MutationObserver(tickHold).observe(cartDialog, { childList: true, subtree: true, attributes: true, attributeFilter: ['open'] });

  /* Reviews on pages without a product (home): the widget comes from the product's reviews view,
     then Judge.me's loader runs again so it mounts. Fetched once the page has finished loading. */
  const loadReviews = async (el) => {
    const url = root.replace(/\/$/, '') + el.dataset.reviewsFrom;
    const doc = new DOMParser().parseFromString(await (await fetch(url)).text(), 'text/html');
    const src = doc.querySelector('[id$="__reviews"] .rvapp__widget');
    if (!src) return;
    el.innerHTML = src.innerHTML;
    el.querySelectorAll('script').forEach((old) => {
      const s = document.createElement('script');
      [...old.attributes].forEach((a) => s.setAttribute(a.name, a.value));
      s.textContent = old.textContent;
      old.replaceWith(s);
    });
    const loader = [...document.scripts].find((s) => /judgeme.*loader.js/.test(s.src))?.src
      || performance.getEntriesByType('resource').map((r) => r.name).find((n) => /judgeme.*loader.js/.test(n));
    if (loader && window.jdgm) {
      window.jdgm._loaderExecuted = false;
      document.body.appendChild(Object.assign(document.createElement('script'), { src: loader }));
    }
  };
  const reviewHosts = $$('[data-reviews-from]');
  if (reviewHosts.length) {
    const go = () => setTimeout(() => reviewHosts.forEach(loadReviews), 800);
    document.readyState === 'complete' ? go() : addEventListener('load', go, { once: true });
  }

  /* Product page ------------------------------------------------------------ */

  // Money formatter derived from the shop's own format ("{{ 100000 | money }}" → "€1.000,00")
  const moneyFormatter = (sample) => {
    const m = /^(.*?)1(\D?)000(?:(\D)00)?(.*)$/.exec(sample || '');
    if (!m) return (c) => (c / 100).toFixed(2);
    const [, pre, thou, dec = ',', post] = m;
    return (c) => {
      const whole = String(Math.floor(c / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      const frac = c % 100;
      return pre + whole + (frac ? dec + String(frac).padStart(2, '0') : '') + post;
    };
  };

  const initProduct = (section) => {
    const form = $('form[action*="/cart/add"]', section);
    const track = $('[data-gallery-track]', section);
    if (!form) return;
    const slides = track ? [...track.children] : [];
    const dots = $$('.gallery__dot', section);
    const addBtn = $('[data-add]', section);
    const errorEl = $('[data-add-error]', section);
    const sticky = $('[data-sticky-atc]', section);
    const offer = $('[data-offer]', section);

    /* Gallery: arrows, dots, swipe */
    const current = () => (track ? Math.round(track.scrollLeft / track.clientWidth) : 0);
    const gallery = $('[data-gallery]', section);
    const setActive = (i) => {
      dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
      // the moving text turns black or white to suit the photo on show
      if (gallery && slides[i]) gallery.dataset.tone = slides[i].dataset.tone || 'dark';
    };
    setActive(0);
    const goTo = (i) => {
      if (!track || !slides.length) return;
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      setActive(i);
    };
    if (track) track.addEventListener('scroll', () => setActive(current()), { passive: true });
    $$('[data-gallery-step]', section).forEach((b) => b.addEventListener('click', () => goTo(current() + Number(b.dataset.galleryStep))));
    $$('[data-gallery-go]', section).forEach((b) => b.addEventListener('click', () => goTo(Number(b.dataset.galleryGo))));
    // Next photo every 3 s while the gallery is on screen; a touch or click holds it for 8 s
    if (gallery && slides.length > 1) {
      let onScreen = true;
      let heldUntil = 0;
      new IntersectionObserver(([e]) => { onScreen = e.isIntersecting; }, { threshold: 0.5 }).observe(gallery); // only while half of it shows
      gallery.addEventListener('pointerdown', () => { heldUntil = Date.now() + 8000; }, { passive: true });
      setInterval(() => { if (onScreen && !document.hidden && Date.now() > heldUntil) goTo(current() + 1); }, 3000);
    }

    /* Packs: each one is a variant with its own price, added to the cart as a single line */
    let lines = null;
    if (offer) {
      const fmt = moneyFormatter(offer.dataset.money);
      const tiers = $$('input[name="offer_tier"]', offer);
      const idInput = $('input[name="id"]', form);
      const addon = $('[data-addon]', section);
      const prog = $('[data-progress]', section);
      const perks = $$('[data-from]', section);
      const picked = () => tiers.find((t) => t.checked) || tiers[0];

      const render = () => {
        const t = picked();
        if (!t) return;
        const i = tiers.indexOf(t);
        if (idInput) idInput.value = t.value;
        // The priority order add-on is added on top, at its own price
        const extra = addon && addon.checked ? Number(addon.dataset.addonPrice) : 0;
        const now = Number(t.dataset.price) + extra;
        const full = Math.max(Number(t.dataset.full), Number(t.dataset.price)) + extra;
        const html = (full > now ? `<s>${fmt(full)}</s> ` : '') + fmt(now);
        $$('[data-total], [data-sticky-price]', section).forEach((el) => { el.innerHTML = html; });
        // What comes with the order: items from bigger packs stay locked until that pack is picked
        perks.forEach((el) => el.classList.toggle('is-locked', Number(el.dataset.from) > i + 1));
        if (prog) {
          const next = tiers[i + 1];
          const saved = Math.max(Number(t.dataset.full) - Number(t.dataset.price), 0);
          $('[data-progress-fill]', prog).style.transform = 'scaleX(' + i / Math.max(tiers.length - 1, 1) + ')'; // transform, not width: no layout on every frame
          $$('.progress__dot', prog).forEach((d, k) => d.classList.toggle('is-done', k <= i));
          $('.progress__save', prog).hidden = !saved;
          $('[data-progress-save]', prog).textContent = fmt(saved);
          $('[data-progress-msg]', prog).textContent = next
            ? offer.dataset.msgNext.replace('[n]', next.dataset.q - t.dataset.q).replace('[free]', next.dataset.q - next.dataset.paid)
            : offer.dataset.msgBest;
        }
      };
      offer.addEventListener('change', render);
      if (addon) addon.addEventListener('change', render);

      lines = () => {
        return [{ id: Number(picked().value), quantity: 1 }];
      };
      render();
    }

    // Add to cart without leaving the page, then open the cart drawer
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const label = $('[data-add-label]', section);
      const original = label ? label.textContent : '';
      addBtn && addBtn.setAttribute('aria-busy', 'true');
      if (label) label.textContent = window.themeStrings?.adding || '…';
      let body;
      let headers = { Accept: 'application/json' };
      if (lines) {
        body = JSON.stringify({ items: lines(), sections: 'cart-drawer', sections_url: location.pathname });
        headers['Content-Type'] = 'application/json';
      } else {
        body = new FormData(form);
        body.append('sections', 'cart-drawer');
        body.append('sections_url', location.pathname);
      }
      try {
        const res = await fetch(root + 'cart/add.js', { method: 'POST', body, headers });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message);
        let sections = data.sections;
        // The priority order is set to exactly one, however many times the button is pressed
        const addon = $('[data-addon]', section);
        if (addon && addon.checked) {
          const upd = await fetch(root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates: { [addon.dataset.addon]: 1 }, sections: 'cart-drawer', sections_url: location.pathname }),
          });
          sections = (await upd.json()).sections || sections;
        }
        renderCart(sections && sections['cart-drawer']);
        openDrawer('cart-drawer');
        if (errorEl) errorEl.hidden = true;
      } catch (err) {
        if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
      } finally {
        addBtn && addBtn.removeAttribute('aria-busy');
        if (label) label.textContent = original;
      }
    });

    // Sticky add to cart appears only once the main button has scrolled above the screen
    // (a plain scroll check: Safari on iPhone showed it straight away with the observer version)
    if (sticky && addBtn) {
      const syncSticky = () => {
        const show = addBtn.getBoundingClientRect().bottom < 0;
        if (sticky.classList.contains('is-visible') === show) return;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
        $('[data-sticky-add]', sticky).tabIndex = show ? 0 : -1;
      };
      addEventListener('scroll', syncSticky, { passive: true });
      addEventListener('resize', syncSticky);
      syncSticky();
    }
  };

  /* Info tabs under the add-to-cart button */
  document.addEventListener('click', (e) => {
    const tab = e.target.closest('[data-itab]');
    if (!tab) return;
    const box = tab.closest('[data-itabs]');
    $$('[data-itab]', box).forEach((t) => {
      const on = t === tab;
      t.setAttribute('aria-selected', String(on));
      document.getElementById(t.getAttribute('aria-controls')).hidden = !on;
    });
  });

  /* Setup guide: the 400px-wide phone drawings scale to their step's width */
  const initGuide = (list) => {
    const stage = $('.qstep__stage', list);
    const fit = () => list.style.setProperty('--k', stage.clientWidth / 400);
    new ResizeObserver(fit).observe(stage);
    fit();
  };

  /* Cookie consent (Shopify Customer Privacy API) -------------------------------------- */
  const ck = $('[data-cookies]');
  if (ck) {
    const prefs = $('[data-cookie-prefs]', ck);
    const show = () => { ck.hidden = false; requestAnimationFrame(() => ck.classList.add('is-in')); };
    const hide = () => { ck.classList.remove('is-in'); setTimeout(() => { ck.hidden = true; }, 350); };
    const withApi = (fn) => {
      if (window.Shopify && Shopify.loadFeatures) {
        Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (err) => { if (!err && Shopify.customerPrivacy) fn(Shopify.customerPrivacy); });
      } else fn(null); // local preview: no Shopify API
    };
    const save = (c) => {
      withApi((api) => {
        if (api) api.setTrackingConsent({ analytics: c.analytics, marketing: c.marketing, preferences: c.preferences, sale_of_data: c.marketing }, () => {});
        try { localStorage.setItem('quietta-cookies', JSON.stringify(c)); } catch (e) {}
      });
      hide();
    };
    ck.addEventListener('click', (e) => {
      if (e.target.closest('[data-cookie-config]')) {
        prefs.hidden = !prefs.hidden;
        $('[data-cookie-config]', ck).hidden = !prefs.hidden;
        $('[data-cookie-choice="custom"]', ck).hidden = prefs.hidden;
        return;
      }
      const b = e.target.closest('[data-cookie-choice]');
      if (!b) return;
      const all = b.dataset.cookieChoice === 'all';
      const pick = (k) => all || (b.dataset.cookieChoice === 'custom' && $(`[data-consent="${k}"]`, ck).checked);
      save({ preferences: pick('preferences'), analytics: pick('analytics'), marketing: pick('marketing') });
    });
    // "Cookie preferences" links anywhere on the page reopen it
    document.addEventListener('click', (e) => { if (e.target.closest('[data-cookie-open]')) { e.preventDefault(); show(); } });
    // until Shopify says whether the notice is needed, the welcome popup waits (see below)
    ck.dataset.pending = '1';
    setTimeout(() => { delete ck.dataset.pending; }, 6000);
    withApi((api) => {
      let need;
      // shouldShowBanner() only says the region needs consent; show it until the visitor has chosen
      if (api) need = (!api.shouldShowBanner || api.shouldShowBanner()) && api.getTrackingConsent() === 'no_interaction';
      else { try { need = !localStorage.getItem('quietta-cookies'); } catch (e) { need = true; } }
      if (need) setTimeout(show, 600);
      setTimeout(() => { delete ck.dataset.pending; }, 700);
    });
  }

  /* Welcome discount popup ------------------------------------------------------------
     States (localStorage "quietta-promo"): none → opens after N seconds on the site (counted
     across pages); "closed" → only the side tab shows; "claimed" → nothing. */
  const promo = $('[data-promo]');
  if (promo) {
    const KEY = 'quietta-promo';
    const store = { get: () => { try { return localStorage.getItem(KEY); } catch (e) { return null; } }, set: (v) => { try { localStorage.setItem(KEY, v); } catch (e) {} } };
    const tab = $('[data-promo-open]', promo);
    const open = () => { promo.classList.add('is-open'); tab.hidden = true; setTimeout(() => $('.promo__box', promo).focus(), 50); };
    const close = () => {
      promo.classList.remove('is-open');
      if (store.get() !== 'claimed') { store.set('closed'); tab.hidden = false; }
    };
    const confetti = () => {
      const colors = ['#0e4a78', '#2a86ea', '#9fd0f2', '#f2b01e', '#ffffff', '#0c1014'];
      const layer = document.createElement('div');
      layer.className = 'confetti';
      document.body.appendChild(layer);
      for (let i = 0; i < 90; i++) {
        const p = document.createElement('i');
        p.style.background = colors[i % colors.length];
        p.style.left = 50 + (Math.random() - 0.5) * 30 + '%';
        layer.appendChild(p);
        const x = (Math.random() - 0.5) * 900, y = -(260 + Math.random() * 380);
        p.animate([
          { transform: 'translate(0, 0) rotate(0deg)', opacity: 1 },
          { transform: `translate(${x * 0.6}px, ${y}px) rotate(${Math.random() * 540}deg)`, opacity: 1, offset: 0.45 },
          { transform: `translate(${x}px, ${y + 900}px) rotate(${Math.random() * 1080}deg)`, opacity: 0 },
        ], { duration: 2200 + Math.random() * 1200, easing: 'cubic-bezier(.2,.6,.3,1)', fill: 'forwards' });
      }
      setTimeout(() => layer.remove(), 3800);
    };

    promo.addEventListener('click', (e) => {
      if (e.target.closest('[data-promo-close]')) close();
      if (e.target.closest('[data-promo-open]')) open();
      const copy = e.target.closest('[data-promo-copy]');
      if (copy) {
        navigator.clipboard?.writeText(copy.dataset.promoCopy);
        $('[data-promo-copied]', copy).hidden = false;
      }
    });
    tab.addEventListener('click', open);
    addEventListener('keydown', (e) => { if (e.key === 'Escape' && promo.classList.contains('is-open')) close(); });

    if ($('[data-promo-success]', promo)) {
      // came back from a successful sign-up: verified + confetti
      store.set('claimed');
      open();
      setTimeout(confetti, 250);
    } else if ($('[data-promo-error]', promo)) {
      open();
    } else if (store.get() === 'closed') {
      tab.hidden = false;
    } else if (store.get() !== 'claimed') {
      let start;
      try { start = Number(sessionStorage.getItem(KEY + '-start')) || Date.now(); sessionStorage.setItem(KEY + '-start', start); } catch (e) { start = Date.now(); }
      const wait = Math.max(0, Number(promo.dataset.delay || 10) * 1000 - (Date.now() - start));
      // never on top of the cookie notice: wait until it has been answered, then give a few seconds of air;
      // and only once the visitor has scrolled into the page, so they see the product first
      let sawCookies = false;
      const scrolled = () => scrollY > innerHeight * 0.6;
      const tryOpen = () => {
        if (promo.classList.contains('is-open') || store.get() === 'closed' || store.get() === 'claimed') return;
        const cookies = $('[data-cookies]');
        if (cookies && (!cookies.hidden || cookies.dataset.pending)) { sawCookies = true; return setTimeout(tryOpen, 1500); }
        if (sawCookies) { sawCookies = false; return setTimeout(tryOpen, 6000); }
        if (!scrolled()) {
          const onScroll = () => { if (scrolled()) { removeEventListener('scroll', onScroll); tryOpen(); } };
          return addEventListener('scroll', onScroll, { passive: true });
        }
        open();
      };
      setTimeout(tryOpen, wait);
    }
  }

  /* Init (and re-init when a section reloads in the theme editor) ------------------ */
  const init = (scope = document) => {
    $$('[data-reveal]', scope).forEach((el) => (designMode ? el.classList.add('is-in') : revealer.observe(el)));
    $$('[data-anim]', scope).forEach((el) => pauser.observe(el));
    $$('[data-product]', scope).forEach(initProduct);
    $$('[data-guide]', scope).forEach(initGuide);
    parallaxItems = $$('[data-parallax]');
    parallax();
  };
  init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
